import styled from 'styled-components';

export const HeaderTitle = styled.h1`
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 25px;
    color: currentColor;
    flex-shrink: 0;
`;